/*
  SMA — Floating Go to top button.
  Appears once the visitor has scrolled past the configured threshold.
  The WhatsApp button is a plain link and needs no script.
*/
(function () {
  'use strict';

  function init() {
    const button = document.querySelector('[data-sma-go-top]');
    if (!button || button.dataset.smaReady === 'true') return;
    button.dataset.smaReady = 'true';

    const parsedThreshold = parseInt(button.dataset.showAfter, 10);
    const threshold = isNaN(parsedThreshold) ? 400 : parsedThreshold;
    let ticking = false;

    const update = function () {
      const y = window.pageYOffset || document.documentElement.scrollTop;
      button.classList.toggle('is-visible', y > threshold);
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    button.addEventListener('click', function () {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();